<template>
  <div class="info-modal">
    <div class="close" @click="close()">x</div>
    <div class="title">
      <slot name="title"></slot>
    </div>
    <div class="text">
      <slot name="text"></slot>
    </div>
    <div class="footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'infoModal',
  components: {
    
  },
  data() {
    return {
      state: this.$store.state,
      ui: {

      }
    }
  },
  props: {
    dismissInSec: Number
  },
  mounted() {
    if (this.dismissInSec) {
      setTimeout(() => {
        this.close()
      }, this.dismissInSec*1000)
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="stylus" scoped>
.info-modal {
  position:fixed
  z-index:1000
  height:90vh
  width:90vw
  max-width: 1200px
  max-height: 800px
  top: 50%;
  transform: translateY(-50%);
  /* add code below to also center horizontally */
  left:0;
  right:0;
  margin: 0 auto;
  background-color: #BF1528
  box-shadow: 0 0 20px 10px rgba(0,0,0,0.4)
  border-radius:50px
  padding:3% 8%
  color:white
}
.close {
  position: absolute
  top:2%
  right 4%
  color:white
  font-size: 60px
  font-weight:bold
  line-height:1
  cursor:pointer
}
.title {
  text-align:center
  font-family: 'FedraSerifAPro'
  margin-top:10%
  font-size:48px
  font-weight:bold
}
.text {
  text-align:center
  margin-top:8%
  font-size:15px
}
.footer {
  text-align:center
  margin-top:15%
  font-size:15px
  font-weight:bold
}

</style>